/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown> }} Product_Option_StockInputs */

const vi_product_option_stock = /** @type {(inputs: Product_Option_StockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tồn: ${i?.qty}`)
};

/**

* @param {Product_Option_StockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_option_stock = /** @type {((inputs: Product_Option_StockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Option_StockInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_option_stock(inputs)
});